export default __webpack_public_path__ + "static/media/greater.4da8e988.svg";